import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Navbar from '../Component/Navbar'
import axiosInstance from '../Api/axiosInstance'

const enterpriseData = JSON.parse(localStorage.getItem("enterpriseData") || "{}")
const ENTERPRISE_ID = enterpriseData._id
const API_BASE = 'https://api.imtransporter.com'

const initialForm = {
    branchName: '',
    ownerId: '',
    address: '',
    city: '',
    state: '',
    noOfTrips: '',
    frequency: 'daily',
    gstNumber: '',
    upiId: '',
    bankAccountNumber: '',
    bankIfscCode: '',
    bankName: '',
    qrCode: null,
}

const OL = '#6b7c3e'
const OL_LIGHT = '#8a9e52'
const OL_PALE = '#f0f4e8'
const OL_HEADER = '#e8eedd'
const OL_DARK = '#3d4a22'

const navItems = [
    { label: 'Dashboard', icon: '📊', path: '/dashboard' },
    { label: 'Trip Details', icon: '🚚', path: '/trip-details' },
    { label: 'Saved Address', icon: '📍', path: '/save-address' },
    { label: 'Employee Details', icon: '👤', path: '/employee-request' },
    { label: 'Branch Details', icon: '🏢', path: '/branch-details' },
    { label: 'Account', icon: '📋', path: '/account' },
]

const statusStyle = {
    Active:   { color: '#15803d', bg: '#dcfce7' },
    Inactive: { color: '#b91c1c', bg: '#fee2e2' },
    pending:  { color: '#b45309', bg: '#fef3c7' },
    approved: { color: '#15803d', bg: '#dcfce7' },
    rejected: { color: '#b91c1c', bg: '#fee2e2' },
}

const FREQUENCY_OPTIONS = ['daily', 'weekly', 'monthly']

const BranchDetails = () => {
    const navigate = useNavigate()
    const [activeNav, setActiveNav] = useState('Branch Details')
    const [branches, setBranches] = useState([])
    const [owners, setOwners] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [form, setForm] = useState(initialForm)
    const [loading, setLoading] = useState(false)
    const [listLoading, setListLoading] = useState(false)
    const [error, setError] = useState('')

    // ── Fetch branch list on page load ──
    useEffect(() => {
        const fetchBranches = async () => {
            setListLoading(true)
            try {
                const res = await axiosInstance.post(
                    `/enterprise/branch/requests`,
                    { page: 1, limit: 10, enterpriseId: ENTERPRISE_ID },
                    { useAuth: true }
                )
                setBranches(res.data?.data || res.data?.branches || res.data || [])
            } catch (err) {
                console.error('Failed to fetch branches:', err)
            } finally {
                setListLoading(false)
            }
        }

        fetchBranches()
    }, [])

    const handleChange = (e) => {
        setError('')
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    const handleFileChange = (e) => {
        setForm({ ...form, qrCode: e.target.files[0] || null })
    }

    const handleSave = async () => {
        const required = ['branchName', 'address', 'city', 'state', 'noOfTrips', 'gstNumber']
        if (required.some((k) => !String(form[k]).trim())) {
            setError('Please fill all required fields.')
            return
        }

        // Build multipart form data to support QR file upload
        const formData = new FormData()
        formData.append('enterpriseId', ENTERPRISE_ID)
        if (form.ownerId) formData.append('ownerId', form.ownerId)
        formData.append('branchName', form.branchName)
        formData.append('gstNumber', form.gstNumber)
        formData.append('address', form.address)
        formData.append('city', form.city)
        formData.append('state', form.state)
        formData.append('noOfTrips', Number(form.noOfTrips))
        formData.append('frequency', form.frequency)
        formData.append('upiId', form.upiId)
        formData.append('bankAccountNumber', form.bankAccountNumber)
        formData.append('bankIfscCode', form.bankIfscCode)
        formData.append('bankName', form.bankName)
        if (form.qrCode) formData.append('qrCode', 'https://example.com/qrcode.png')

        setLoading(true)
        setError('')

        try {
            await axiosInstance.post(
                `/enterprise/branch/register/request`,
                formData,
                {
                    useAuth: true,
                    headers: { 'Content-Type': 'multipart/form-data' },
                }
            )

            setBranches(prev => [...prev, {
                branchName: form.branchName,
                gstNumber: form.gstNumber,
                address: form.address,
                city: form.city,
                state: form.state,
                noOfTrips: form.noOfTrips,
                frequency: form.frequency,
                upiId: form.upiId,
                bankName: form.bankName,
                status: 'pending',
            }])
            setForm(initialForm)
            setShowModal(false)
        } catch (err) {
            const message = err?.response?.data?.message || err.message || 'Failed to add branch.'
            setError(message)
        } finally {
            setLoading(false)
        }
    }

    const handleCloseModal = () => {
        if (!loading) {
            setShowModal(false)
            setError('')
            setForm(initialForm)
        }
    }

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
                * { box-sizing: border-box; margin: 0; padding: 0; }
                body { font-family: 'DM Sans', sans-serif; }
                .bd-nav-btn:hover  { background: ${OL_PALE} !important; color: ${OL_DARK} !important; }
                .bd-row:hover td   { background: #f4f7f0 !important; }
                .bd-add-btn:hover  { background: ${OL_LIGHT} !important; }
                .bd-edit-btn:hover { background: ${OL_PALE} !important; }
                .bd-del-btn:hover  { background: #fee2e2 !important; }
                .bd-cancel:hover   { background: #f3f4f6 !important; }
                .bd-input:focus {
                    border-color: ${OL} !important;
                    box-shadow: 0 0 0 3px rgba(107,124,62,0.12) !important;
                    background: #fff !important;
                    outline: none;
                }
                .bd-save-btn:hover:not(:disabled) { background: ${OL_LIGHT} !important; }
                .bd-save-btn:disabled { opacity: 0.65; cursor: not-allowed; }
                .bd-spinner {
                    display: inline-block;
                    width: 14px; height: 14px;
                    border: 2px solid rgba(255,255,255,0.4);
                    border-top-color: #fff;
                    border-radius: 50%;
                    animation: spin 0.7s linear infinite;
                    margin-right: 6px;
                    vertical-align: middle;
                }
                .bd-list-spinner {
                    display: inline-block;
                    width: 22px; height: 22px;
                    border: 3px solid rgba(107,124,62,0.2);
                    border-top-color: ${OL};
                    border-radius: 50%;
                    animation: spin 0.7s linear infinite;
                }
                .bd-file-input {
                    border: 1.5px solid #e0e5d4;
                    borderRadius: 8px;
                    padding: 7px 10px;
                    background: ${OL_PALE};
                    width: 100%;
                    font-family: 'DM Sans', sans-serif;
                    font-size: 0.88rem;
                    cursor: pointer;
                }
                @keyframes spin { to { transform: rotate(360deg); } }
            `}</style>

            <Navbar />
            <div style={S.shell}>

                {/* ── Sidebar ── */}
                <aside style={S.sidebar}>
                    <div style={S.sidebarLogo}>
                        <span style={S.logoIcon}>🚛</span>
                        <span style={S.logoText}>Menu</span>
                    </div>
                    <nav style={S.nav}>
                        {navItems.map((item) => (
                            <button
                                key={item.label}
                                className="bd-nav-btn"
                                style={{
                                    ...S.navItem,
                                    ...(activeNav === item.label ? S.navItemActive : {}),
                                }}
                                onClick={() => {
                                    setActiveNav(item.label)
                                    if (item.path) navigate(item.path)
                                }}
                            >
                                <span style={S.navIcon}>{item.icon}</span>
                                <span>{item.label}</span>
                                {activeNav === item.label && <span style={S.navIndicator} />}
                            </button>
                        ))}
                    </nav>
                </aside>

                {/* ── Main ── */}
                <main style={S.main}>
                    <div style={S.header}>
                        <div>
                            <h1 style={S.title}>Branch Details</h1>
                            <p style={S.subtitle}>Manage and track all enterprise branches</p>
                        </div>
                        <button className="bd-add-btn" style={S.addBtn} onClick={() => setShowModal(true)}>
                            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                <path d="M12 5v14M5 12h14" />
                            </svg>
                            Add Branch
                        </button>
                    </div>

                    {/* Table */}
                    <div style={S.tableWrapper}>
                        <table style={S.table}>
                            <thead>
                                <tr>
                                    {['Branch Name', 'GST No', 'Address', 'City', 'No. of Trips', 'Frequency', 'Status'].map((h) => (
                                        <th key={h} style={S.th}>{h}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {listLoading ? (
                                    <tr>
                                        <td colSpan={8} style={S.emptyCell}>
                                            <div style={S.emptyState}>
                                                <span className="bd-list-spinner" />
                                                <p style={{ color: '#888' }}>Loading branches...</p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : branches.length === 0 ? (
                                    <tr>
                                        <td colSpan={8} style={S.emptyCell}>
                                            <div style={S.emptyState}>
                                                <span style={{ fontSize: 38 }}>🏢</span>
                                                <p>No branches found</p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    branches.map((b, i) => {
                                        const statusKey = b.status || 'pending'
                                        const st = statusStyle[statusKey] || statusStyle.pending
                                        return (
                                            <tr key={i} className="bd-row" style={S.tr}>
                                                <td style={{ ...S.td, fontWeight: 600, color: OL_DARK }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                        <span style={S.branchIcon}>🏢</span>
                                                        {b.branchName}
                                                    </div>
                                                </td>
                                                <td style={S.td}>
                                                    <span style={S.gstBadge}>{b.gstNumber}</span>
                                                </td>
                                                <td style={{ ...S.td, maxWidth: 160, color: '#555' }}>{b.address}</td>
                                                <td style={S.td}>{b.city}</td>
                                                <td style={S.td}>
                                                    <span style={S.tripCount}>{b.noOfTrips ?? '—'}</span>
                                                </td>
                                                <td style={S.td}>
                                                    <span style={S.freqBadge}>{b.frequency || '—'}</span>
                                                </td>
                                                {/* <td style={S.td}>{b.bankName || '—'}</td> */}
                                                <td style={S.td}>
                                                    <span style={{
                                                        ...S.statusBadge,
                                                        color: st.color,
                                                        background: st.bg,
                                                        border: `1px solid ${st.color}40`,
                                                    }}>
                                                        {statusKey}
                                                    </span>
                                                </td>
                                            </tr>
                                        )
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                </main>
            </div>

            {/* ── Modal ── */}
            {showModal && (
                <div style={S.overlay} onClick={(e) => e.target === e.currentTarget && handleCloseModal()}>
                    <div style={S.modal}>
                        <div style={S.modalHeader}>
                            <div>
                                <span style={S.modalTitle}>Add Branch</span>
                                <p style={S.modalSubtitle}>Enter the following details to add a branch:</p>
                            </div>
                            <button style={S.closeBtn} onClick={handleCloseModal} disabled={loading}>✕</button>
                        </div>

                        <div style={S.formGrid}>

                            {/* Branch Name */}
                            <div style={S.formGroup}>
                                <input className="bd-input" style={S.input} type="text"
                                    name="branchName" value={form.branchName} onChange={handleChange}
                                    placeholder="Branch Name" />
                            </div>

                            {/* Select Owner */}
                            <div style={S.formGroup}>
                                <input className="bd-input" style={S.input} type="text"
                                    name="ownerId" value={form.ownerId} onChange={handleChange}
                                    placeholder="Owner ID (optional)" />
                            </div>

                            {/* Address */}
                            <div style={S.formGroup}>
                                <input className="bd-input" style={S.input} type="text"
                                    name="address" value={form.address} onChange={handleChange}
                                    placeholder="Address" />
                            </div>

                            {/* City */}
                            <div style={S.formGroup}>
                                <input className="bd-input" style={S.input} type="text"
                                    name="city" value={form.city} onChange={handleChange}
                                    placeholder="City" />
                            </div>

                            {/* State */}
                            <div style={S.formGroup}>
                                <input className="bd-input" style={S.input} type="text"
                                    name="state" value={form.state} onChange={handleChange}
                                    placeholder="State" />
                            </div>

                            {/* No of Trips */}
                            <div style={S.formGroup}>
                                <input className="bd-input" style={S.input} type="number"
                                    name="noOfTrips" value={form.noOfTrips} onChange={handleChange}
                                    placeholder="No of Trips" min="0" />
                            </div>

                            {/* Frequency */}
                            <div style={S.formGroup}>
                                <select className="bd-input" style={S.input}
                                    name="frequency" value={form.frequency} onChange={handleChange}>
                                    {FREQUENCY_OPTIONS.map(f => (
                                        <option key={f} value={f}>
                                            {f.charAt(0).toUpperCase() + f.slice(1)}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* GST Number */}
                            <div style={S.formGroup}>
                                <input className="bd-input" style={S.input} type="text"
                                    name="gstNumber" value={form.gstNumber} onChange={handleChange}
                                    placeholder="GST Number" />
                            </div>

                            {/* UPI ID */}
                            <div style={S.formGroup}>
                                <input className="bd-input" style={S.input} type="text"
                                    name="upiId" value={form.upiId} onChange={handleChange}
                                    placeholder="UPI ID" />
                            </div>

                            {/* Bank Account Number */}
                            <div style={S.formGroup}>
                                <input className="bd-input" style={S.input} type="text"
                                    name="bankAccountNumber" value={form.bankAccountNumber} onChange={handleChange}
                                    placeholder="Bank Account Number" />
                            </div>

                            {/* IFSC Code */}
                            <div style={S.formGroup}>
                                <input className="bd-input" style={S.input} type="text"
                                    name="bankIfscCode" value={form.bankIfscCode} onChange={handleChange}
                                    placeholder="IFSC Code" />
                            </div>

                            {/* Bank Name */}
                            <div style={S.formGroup}>
                                <input className="bd-input" style={S.input} type="text"
                                    name="bankName" value={form.bankName} onChange={handleChange}
                                    placeholder="Bank Name" />
                            </div>

                            {/* Upload QR — full width */}
                            <div style={{ ...S.formGroup, gridColumn: '1 / -1' }}>
                                <label style={S.label}>UPLOAD QR</label>
                                <input
                                    className="bd-input"
                                    style={{ ...S.input, padding: '7px 10px', cursor: 'pointer' }}
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                />
                            </div>
                        </div>

                        {error && (
                            <div style={S.errorBox}>
                                <span>⚠️</span> {error}
                            </div>
                        )}

                        <div style={S.modalActions}>
                            <button className="bd-cancel" style={S.cancelBtn}
                                onClick={handleCloseModal} disabled={loading}>
                                Cancel
                            </button>
                            <button
                                className="bd-save-btn"
                                style={S.saveBtn}
                                onClick={handleSave}
                                disabled={loading}
                            >
                                {loading && <span className="bd-spinner" />}
                                {loading ? 'Adding...' : 'Add Branch'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default BranchDetails

// ─── Styles ───────────────────────────────────────────────────────────────────

const S = {
    shell: {
        display: 'flex', minHeight: '100vh',
        fontFamily: "'DM Sans', sans-serif",
        background: '#f7f8f4', color: '#2c2c2c',
    },
    sidebar: {
        width: 220, background: '#fff',
        borderRight: '1px solid #e0e5d4',
        display: 'flex', flexDirection: 'column',
        padding: '24px 0', flexShrink: 0,
        boxShadow: '2px 0 12px rgba(107,124,62,0.07)',
    },
    sidebarLogo: {
        display: 'flex', alignItems: 'center', gap: 10,
        padding: '0 20px 24px', borderBottom: '1px solid #e8eedd', marginBottom: 12,
    },
    logoIcon: { fontSize: 22 },
    logoText: { fontSize: 18, fontWeight: 700, color: OL_DARK, letterSpacing: '-0.3px' },
    nav: { display: 'flex', flexDirection: 'column', gap: 2, padding: '0 10px' },
    navItem: {
        display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px',
        borderRadius: 10, border: 'none', background: 'transparent', cursor: 'pointer',
        fontSize: 14, fontWeight: 500, color: '#666', textAlign: 'left',
        position: 'relative', transition: 'all 0.18s ease', fontFamily: "'DM Sans', sans-serif",
    },
    navItemActive: { background: OL_PALE, color: OL_DARK, fontWeight: 600 },
    navIcon: { fontSize: 15 },
    navIndicator: {
        position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)',
        width: 3, height: 20, borderRadius: '0 3px 3px 0', background: OL,
    },
    main: { flex: 1, padding: '32px 36px', overflow: 'auto' },
    header: {
        display: 'flex', alignItems: 'flex-start',
        justifyContent: 'space-between', marginBottom: 28,
    },
    title: { fontSize: 26, fontWeight: 700, color: OL_DARK, letterSpacing: '-0.5px' },
    subtitle: { fontSize: 13, color: '#888', marginTop: 3 },
    addBtn: {
        display: 'inline-flex', alignItems: 'center', gap: 7,
        background: OL, color: '#fff', border: 'none', borderRadius: 9,
        padding: '10px 20px', fontSize: 14, fontWeight: 600, cursor: 'pointer',
        fontFamily: "'DM Sans', sans-serif",
        boxShadow: '0 2px 8px rgba(107,124,62,0.22)', transition: 'background 0.15s',
        whiteSpace: 'nowrap',
    },
    tableWrapper: {
        background: '#fff', borderRadius: 14, border: '1px solid #e2e8d4',
        overflow: 'hidden', boxShadow: '0 2px 16px rgba(107,124,62,0.07)',
    },
    table: { width: '100%', borderCollapse: 'collapse', fontSize: 14 },
    th: {
        background: OL_HEADER, color: OL_DARK, fontWeight: 600,
        padding: '13px 16px', textAlign: 'left', fontSize: 13,
        letterSpacing: '0.01em', borderBottom: `2px solid ${OL}30`,
        whiteSpace: 'nowrap',
    },
    tr: { borderBottom: '1px solid #eef1e8', transition: 'background 0.15s' },
    td: {
        padding: '13px 16px', color: '#3a3a3a', verticalAlign: 'middle',
        background: '#fff', transition: 'background 0.15s',
    },
    branchIcon: { fontSize: 16 },
    gstBadge: {
        display: 'inline-block', background: OL_PALE, color: OL_DARK,
        borderRadius: 6, padding: '3px 10px', fontSize: 11, fontWeight: 700,
        border: `1px solid ${OL}30`, fontFamily: 'monospace', letterSpacing: '0.04em',
    },
    freqBadge: {
        display: 'inline-block', background: '#f0f4e8', color: OL_DARK,
        borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 600,
        textTransform: 'capitalize',
    },
    tripCount: {
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        background: OL_PALE, color: OL_DARK, borderRadius: 20,
        padding: '2px 12px', fontSize: 13, fontWeight: 700, minWidth: 32,
    },
    statusBadge: {
        display: 'inline-block', padding: '4px 12px', borderRadius: 20,
        fontSize: 12, fontWeight: 700, letterSpacing: '0.03em', textTransform: 'capitalize',
    },
    emptyCell: { padding: '52px 16px' },
    emptyState: {
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        gap: 10, color: '#aaa', fontSize: 15,
    },
    overlay: {
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.28)',
        backdropFilter: 'blur(2px)', zIndex: 100,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
    },
    modal: {
        background: '#fff', borderRadius: 18,
        boxShadow: '0 8px 48px rgba(0,0,0,0.16)',
        width: 600, maxWidth: '95vw', padding: '32px 32px 28px',
        maxHeight: '90vh', overflowY: 'auto',
    },
    modalHeader: {
        display: 'flex', alignItems: 'flex-start',
        justifyContent: 'space-between', marginBottom: 22,
    },
    modalTitle: { fontSize: '1.3rem', fontWeight: 700, color: '#1a1a1a', display: 'block' },
    modalSubtitle: { fontSize: 13, color: '#888', marginTop: 4 },
    closeBtn: {
        background: 'transparent', border: 'none', borderRadius: 8,
        width: 32, height: 32, cursor: 'pointer', fontSize: '1.1rem',
        color: '#4b5563', display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
    },
    formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px 16px' },
    formGroup: { display: 'flex', flexDirection: 'column', gap: 5 },
    label: { fontSize: '0.75rem', fontWeight: 700, color: '#4b5563', letterSpacing: '0.04em' },
    input: {
        border: '1.5px solid #e0e5d4', borderRadius: 8, padding: '10px 14px',
        fontFamily: "'DM Sans', sans-serif", fontSize: '0.91rem', color: '#1f2937',
        background: '#fff', transition: 'border 0.13s, box-shadow 0.13s', width: '100%',
    },
    errorBox: {
        marginTop: 14, padding: '10px 14px', background: '#fff1f2',
        border: '1.5px solid #fca5a5', borderRadius: 8,
        color: '#b91c1c', fontSize: 13, fontWeight: 500,
        display: 'flex', alignItems: 'center', gap: 8,
    },
    modalActions: {
        display: 'flex', gap: 10, justifyContent: 'center', marginTop: 24,
    },
    cancelBtn: {
        border: '1.5px solid #e5e7eb', background: '#fff', color: '#4b5563',
        borderRadius: 8, padding: '10px 28px', fontFamily: "'DM Sans', sans-serif",
        fontSize: '0.91rem', fontWeight: 600, cursor: 'pointer', transition: 'background 0.13s',
    },
    saveBtn: {
        background: OL, color: '#fff', border: 'none', borderRadius: 8,
        padding: '10px 48px', fontFamily: "'DM Sans', sans-serif",
        fontSize: '0.95rem', fontWeight: 600, cursor: 'pointer',
        transition: 'background 0.15s', display: 'inline-flex', alignItems: 'center',
    },
}